import { useNavigate, useLocation } from 'react-router-dom';
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarFooter
} from '../components/ui/sidebar';
import { useAtom } from 'jotai';
import { user } from '../state/atoms/user.atom';
import { AppNavItem } from '../types/nav.types';
import { cn } from 'lib/utils';
import { ACCOUNT_NAV_ITEMS, MAIN_NAV_ITEMS } from './nav-items';

export function AppSideBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData] = useAtom(user);

  const isVisible = (item: AppNavItem) => !item.requiresAuth || !!userData;

  const handleClick = (item: AppNavItem) => {
    if (item.isExternal) {
      window.open(item.path, '_blank');

      return;
    }

    navigate(item.path);
  };

  const renderNavItem = (item: AppNavItem) => {
    const Icon = item.icon;
    const isActive = !item.isExternal && location.pathname === item.path;
    // The account entry shows who is signed in, as in the design
    const label = item.path === '/settings' && userData?.email ? userData.email : item.label;

    return (
      <button
        key={item.path}
        type='button'
        title={label}
        aria-current={isActive ? 'page' : undefined}
        className={cn(
          'mb-0.5 flex h-11 w-full items-center gap-3 rounded-full px-4 text-left font-medium text-ob-text-secondary transition-colors duration-150 hover:bg-ob-canvas focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ob-focus',
          isActive && 'bg-ob-canvas',
        )}
        onClick={() => handleClick(item)}
      >
        <Icon className='h-5 w-5 shrink-0 text-ob-icon' />
        <span className='truncate'>{label}</span>
      </button>
    );
  };

  return (
    <Sidebar className='font-ob group-data-[side=left]:border-r-0'>
      <SidebarHeader className='px-8 pb-0 pt-[39px]'>
        <img src='/1browser-logo.svg' alt='1browser' width={140} height={29} />
      </SidebarHeader>
      <SidebarContent className='px-4 pt-8'>
        <nav aria-label='Main navigation'>
          {MAIN_NAV_ITEMS.filter(isVisible).map(renderNavItem)}
        </nav>
      </SidebarContent>
      <SidebarFooter className='px-4 pb-6'>
        <nav aria-label='Account navigation'>
          {ACCOUNT_NAV_ITEMS.filter(isVisible).map(renderNavItem)}
        </nav>
      </SidebarFooter>
    </Sidebar>
  );
}
